import { Component, OnInit, Input } from '@angular/core';
import { DataWpServiceServAdic } from '../../data-wp.service';
import { PostI } from '../../post.interface';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-nav-servicios',
  templateUrl: './nav-servicios.component.html',
  styleUrls: ['./nav-servicios.component.css'],
  providers: [DataWpServiceServAdic]
})
export class NavServiciosComponent implements OnInit {
  @Input() slugId;
  
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 1
        }
      }
    ]
  };
  

  posts: PostI[];
  constructor( private postsService: DataWpServiceServAdic, private router: Router) { }
  ngOnInit() {
    this.postsService.getPosts().subscribe( 
      (posts: PostI[]) => this.posts = posts, 
      (err: HttpErrorResponse) => err.error instanceof Error ? console.log('An error occurred:', err.error.message) : console.log(`Backend returned code ${err.status}, body was: ${err.error}`));
  }
  selectPost(slug) {
  	this.router.navigate([slug]);
  }





}
